// import RegisterIcon from "@/assets/images/png/step-register.png";
// import ProfileIcon from "@/assets/images/png/step-profile-set.png";
// import ApprovalIcon from "@/assets/images/png/step-approval.png";
// import SubscribeIcon from "@/assets/images/png/step-subscription.png";
// import PartnerIcon from "@/assets/images/png/step-partner.png";
// import registerProcess from "@/assets/images/jpg/register-process.jpg";
// import PromotionIcon from "@/assets/images/png/step-promotion.png";

import RegisterIcon from "@/assets/images/webp/step-register.webp";
import ProfileIcon from "@/assets/images/webp/step-profile-set.webp";
import ApprovalIcon from "@/assets/images/webp/step-approval.webp";
import SubscribeIcon from "@/assets/images/webp/step-subscription.webp";
import PartnerIcon from "@/assets/images/webp/step-partner.webp";
import registerProcess from "@/assets/images/webp/join-logistic-step-img.webp";
import supplierRegProcess from "@/assets/images/webp/become-supplier-steps.webp";
import PromotionIcon from "@/assets/images/webp/step-promotion.webp";
import { motion } from "framer-motion";

const RegistrationSteps = ({ sectionTitle = "", pageName = "", subTitle = "" }) => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  return (<section className="stepper-wrape join-logistics-step">

    <div className={pageName === "supplier" ? 'become inner-pad-bg' : 'inner-pad-bg'}>
      <div className="container">
        {sectionTitle && <div className="head-text center">
          <motion.h2 className="head animate-child center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.2}
            variants={fadeUpVariant}
          >
            {sectionTitle}
          </motion.h2>
          <motion.p className="animate-child"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.2}
            variants={fadeUpVariant}
          > {subTitle}</motion.p>
        </div>}


        <div className="row">
          <div className="col-xxl-5 col-xl-6 col-lg-5">
            <div className="img-wrape stepper-img">
              {
                pageName === "supplier" ? <motion.img src={supplierRegProcess} alt="Register" loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                ></motion.img> : <motion.img src={registerProcess} alt="Register" loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                ></motion.img>
              }

            </div>
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-7 counter-pad">
            <div className="step-pad">
              <div className="icon">
                <motion.img src={RegisterIcon} alt="Register" loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail">
                <motion.h5 className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Register</motion.h5>
                <motion.p className="">Register for free and become part of a trusted global trade community.</motion.p>
              </div>
            </div>
            <div className="step-pad">
              <div className="icon">
                <motion.img src={ProfileIcon} alt="Profile" loading="lazy" className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail">
                <motion.h5 className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Set up Profile</motion.h5>
                <motion.p className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Set up your profile and introduce your company to the global marketplace. Connect with partners worldwide to grow your business.</motion.p>
              </div>
            </div>
            <div className="step-pad">
              <div className="icon">
                <motion.img src={ApprovalIcon} alt="Approval" loading="lazy" className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail">
                <motion.h5
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Submit for approval</motion.h5>
                <motion.p
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Submit for approval to activate your account. Our verification process ensures only genuine businesses join the Orex Trade network.</motion.p>
              </div>
            </div>
            {
              pageName === "supplier" && <div className="step-pad">
                <div className="icon">
                  <motion.img src={PromotionIcon} alt="Promotion" loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h5 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Free Email Promotion</motion.h5>
                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Promote your products and company to targeted buyers worldwide through free email campaigns.</motion.p>
                </div>
              </div>
            }
            <div className="step-pad">
              <div className="icon">
                <motion.img src={SubscribeIcon} alt="Subscription" loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail">
                <motion.h5 className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Pick up Subscription</motion.h5>
                <motion.p
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Choose the subscription plan that best fits your business needs to unlock premium features and maximize your growth potential.</motion.p>
              </div>
            </div>
            <div className="step-pad">
              <div className="icon">
                <motion.img src={PartnerIcon} alt="Partners" loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail">
                <motion.h5 className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Find Partners</motion.h5>
                <motion.p
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Discover reliable partners across industries and countries. Build lasting collaborations that drive growth and success.</motion.p>
              </div>
            </div>
          </div>
          <div className="col-xxl-1 col-xl-1 col-lg-12"></div>
        </div>
      </div>
    </div>
  </section>)
}

export default RegistrationSteps;